import { render } from "./chatWindowWrapper.vue?vue&type=template&id=c39727a4&scoped=true"
import script from "./chatWindowWrapper.vue?vue&type=script&lang=js"
export * from "./chatWindowWrapper.vue?vue&type=script&lang=js"

import "./chatWindowWrapper.vue?vue&type=style&index=0&id=c39727a4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c39727a4"]])

export default __exports__